// removed by extract-text-webpack-plugin
module.exports = {"element":"theme__element___ke_UD","icon":"theme__icon___209jU","curtain":"theme__curtain___2Dmmc","type":"theme__type___2ucks","clip":"theme__clip___2hRaQ","value":"theme__value___1K7ik","collapsed":"theme__collapsed___284P7","fadeUp":"theme__fadeUp___2RG9Q","lateFadeUp":"theme__lateFadeUp___24AxL","lateFadeIn":"theme__lateFadeIn___2Oj0o"};


//////////////////
// WEBPACK FOOTER
// ./client/modules/debate/components/Part/Element/theme.scss
// module id = 1284
// module chunks = 0